import { gql } from '@apollo/client'
import thumbnailBlogFragment from '~/graphql/fragments/thumbnailBlog'
import thumbnailEventCollection from '~/graphql/fragments/thumbnailEventCollection'
import thumbnailWithUrl from '~/graphql/fragments/thumbnailWithUrl'
import groupCollection from '~/graphql/fragments/groupCollection'
import recurringEventCollection from '~/graphql/fragments/recurringEventCollection'

const GET_FEED_ITEMS = gql`
  query getFeedItems($countryCode: CountryCode) {
    explore(countryCode: $countryCode) {
      feed(first: 20) {
        edges {
          node {
            ...thumbnailBlog
            ...thumbnailEventCollection
            ...thumbnailWithUrl
            ...groupCollection
            ...recurringEventCollection
          }
        }
      }
    }
  }

  ${thumbnailBlogFragment}
  ${thumbnailEventCollection}
  ${thumbnailWithUrl}
  ${groupCollection}
  ${recurringEventCollection}
`

export default GET_FEED_ITEMS
